module.exports = __webpack_public_path__ + "static/media/badge-loyalty.b6ce9ddc.png";